function togglePasswordVisibility(): void {
    const passwordInput = document.getElementById('user_password') as HTMLInputElement;
    const eyeIcon = document.getElementById('eye-icon') as HTMLElement;
    const eyeSlashIcon = document.getElementById('eye-slash-icon') as HTMLElement;

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        eyeSlashIcon.style.display = 'none';
        eyeIcon.style.display = 'inline';
    } else {
        passwordInput.type = 'password';
        eyeSlashIcon.style.display = 'inline';
        eyeIcon.style.display = 'none';
    }
}

// Ensure the function is globally accessible
(window as any).togglePasswordVisibility = togglePasswordVisibility;
